import React, {Component} from 'react';
import {Button, Col} from "react-bootstrap";
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import moment from 'moment'
import FaEnvelop from 'react-icons/lib/fa/envelope-o';
import {
    prepareSelectOptionsList,
    actionsFormatter,
    historyDataFormatter,
    dateFormatter,
    customFormatter,imagesFormatter,
    getFieldByPathFormatter
} from 'util/Utils';

  import config from  '../../../config';
import {Link} from "react-router";


class AdminFulfillmentListTable extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props) {
        super(props);
        this.state = {
            perPage: config.table.numberPerPage,
            currentRecord: {},
            adminFulfillments: []

        };
    }

    customActionsFormatter(cell, row, extra) {
        var menuItemsMap = []
         if (this.props.currentTab == 'DeliverySchedule') {
            return  _.get(row, 'ShopifyOrderShippingAddress.province_code') && <div>

                <div>
                    <Button bsStyle="link">
                        <Link className="underlineText"
                              onClick={() => this.props.prepareMultipleOrdersScreen(row, 'EditContactInfoScreen')}>Edit</Link>
                    </Button>
                </div>

                    <Button className="btn btn-primary pleft3 pright3" style={{whiteSpace: 'normal'}}
                    onClick={() => this.props.prepareMultipleOrdersScreen( row,'ChooseDeliverySuggestionScreen',)}>
                    Schedule
                    </Button>
                    {_.size(_.get(row, 'ConnectedTransactionsData.ConnectedTransactions', [])) > 0 &&
                    <div><Button bsStyle="link">
                        <Link className="underlineText"
                              onClick={(e) => {
                                   row.connectedOrdersAction = 'uncombine'
                                  this.props.prepareMultipleOrdersScreen(row, 'UpdateConnectedTransactionsScreen')
                              }}>Un-combine</Link>
                    </Button></div>
                    }

            </div>
        }
        return actionsFormatter.call(this, cell, row, {menuItemsMap})
    }



    editRecord(row) {
        this.props.editRecord(row);
    }



    render() {
         return (
            <div className=" databases-table">
                <BootstrapTable data={this.props.tableData} ref='table'
                                remote={true}
                                hover={true}
                                condensed={true}
                                striped={true}
                                options={ {
                                    ...config.bootstrapTableOptions,
                                    onSortChange: this.props.onSortChange
                                } } >
                    {/*<TableHeaderColumn width="100px" dataAlign="center" dataField='Name'*/}
                    {/*                   dataFormat={ customFormatter } formatExtraData={ {*/}
                    {/*    path: ['Name'] , format: (value, arg2) => {*/}
                    {/*        return _.startCase(value)*/}
                    {/*    }*/}
                    {/*}}        dataSort={true}>Name</TableHeaderColumn>*/}


                    {/*<TableHeaderColumn width="45px" dataAlign="center" dataField='Data'*/}
                    {/*dataFormat={ customFormatter } formatExtraData={ {*/}
                    {/*path: ['Data'] , format: (value, arg2) => {*/}
                        {/*return JSON.stringify(value)*/}
                    {/*}*/}
                {/*}} editable={ false } dataSort={true}>Percent</TableHeaderColumn>*/}
                    <TableHeaderColumn  width="100px" dataField="id" isKey={true}  hidden={true} autoValue={ true } hiddenOnInsert>Id</TableHeaderColumn>
                    <TableHeaderColumn width="40px" dataAlign="center" dataField="SaleData.OrderNumber"
                                    dataFormat={ customFormatter }
                                       formatExtraData={ {
                                           path: 'getObject',
                                           format: (row) => {
                                                  return  <div>

                                                   <a target="_blank" className=""
                                                      href={ config.getEnvironment().shopify.orderUrlTemplate.replace("[link_value]", row.SaleData['OrderID']) }>{_.get(row,'SaleData.OrderNumber', 'n/a')}</a>
                                                      { _.includes(_.get(row, 'SaleData.ShopifyOrderTags', []), 'FirstOrderNote')   &&

                                                     <a title="First order note" href="#" ><FaEnvelop  className="left10 purple" style={{position:'relative', top:-3, width: 24, fontSize: 24,}}
                                                                             name={'envelope-letter'}/></a>
                                                      }
                                                    {_.size(_.get(row, 'ConnectedTransactionsData.ConnectedTransactions', [])) > 0 ?

                                                            <div className="top10">
                                                                { _.map(_.reject(_.get(row, 'ConnectedTransactionsData.ConnectedTransactions', []), item => {
                                                                    return _.get(item, 'ShopifyOrderNumber') == _.get(row, 'SaleData.OrderNumber')
                                                                }), item => {
                                                                    return <a style={{display:'block'}} target="_blank" key={_.get(item, 'ShopifyOrderID')}  className="right5"
                                                                              href={ config.getEnvironment().shopify.orderUrlTemplate.replace("[link_value]", _.get(item, 'ShopifyOrderID', 'n/a')) }>{_.get(item, 'ShopifyOrderNumber', 'n/a')}</a>
                                                                })
                                                                }
                                                             </div>
                                                         :
                                                        <div>
                                                            {_.size(_.get(row, 'ShopifyCustomerTransactions', [])) > 0 &&
                                                            <div className="top10">
                                                                <a href="" className="pleft5 pink  "
                                                                   onClick={(e) => {
                                                                       e.preventDefault()
                                                                       row.connectedOrdersAction = 'combine'
                                                                       this.props.prepareMultipleOrdersScreen(row, 'UpdateConnectedTransactionsScreen')
                                                                   }}
                                                                >{'Combine with ' + _.uniq(_.map(_.get(row, 'ShopifyCustomerTransactions', []), item => {
                                                                    return _.get(item, 'OrderNumber')
                                                                })).join(', ') }
                                                                </a>
                                                            </div>
                                                            }
                                                        </div>
                                                    }
                                                </div>

                                           }
                                       }}
                                       dataSort={true}  >Order №</TableHeaderColumn>


                    <TableHeaderColumn width="40px" dataField="SaleData.OrderCreateDate" dataAlign="center"
                                       dataFormat={ dateFormatter }
                                       editable={ false }
                                       formatExtraData={ {'path': 'SaleData.OrderCreateDate', 'format': 'MM/DD'} }
                                       dataSort={true}>Order Date</TableHeaderColumn>
                    <TableHeaderColumn width="100px"
                                       editable={ false }    dataFormat={ dateFormatter }
                                       formatExtraData={ {'path': 'FulfillByDate', 'format': 'MM/DD'} }

                                       dataField='FulfillByDate' dataAlign="center"
                                       dataSort={true}>Fulfill By</TableHeaderColumn>
                    <TableHeaderColumn width="100px"
                                       editable={ false } dataFormat={ customFormatter }
                                       formatExtraData={ {
                                           path: ['getObject'],
                                           format: (record) => {
                                                if (_.get(record, 'ShopifyOrderShippingAddress.province_code')) {
                                                    return <div>
                                                        <div>{_.get(record.ShopifyOrderShippingAddress, 'address1', 'n/a') + ' ' + _.get(record.ShopifyOrderShippingAddress, 'address2', 'n/a') + ' ' + _.get(record.ShopifyOrderShippingAddress, 'city', '') + ', ' + _.get(record.ShopifyOrderShippingAddress, 'province_code', '') + ' ' + _.get(record.ShopifyOrderShippingAddress, 'zip', '')}</div>
                                                        {_.get(record.ShopifyOrderShippingAddress, 'phone') &&
                                                        <div
                                                            className="top10">{_.get(record.ShopifyOrderShippingAddress, 'phone')}</div>
                                                        }
                                                        </div>
                                                }}}
                                           }

                                       dataField='ShopifyOrderShippingAddress.province_code' dataAlign="center"
                                       dataSort={true}>Contacts</TableHeaderColumn>


                    <TableHeaderColumn width="40px" dataAlign="center" dataField='Status'
                                       dataFormat={ customFormatter }
                                       formatExtraData={ {
                                           path: ['getObject'],
                                           format: (record) => {
                                               if (_.size(_.get(record, 'ConnectedTransactionsData.ConnectedTransactions', []))) {
                                                   var ConnectedTransactionsData = _.reduce(_.get(record, 'ConnectedTransactionsData.ConnectedTransactions', []), function (transactionsData, item) {
                                                       _.forEach(_.get(item, 'Transactions', []), transactionData => {
                                                           transactionsData.push(transactionData)
                                                       })
                                                       return transactionsData
                                                   }, [])
                                                   var transactionsToCheck = _.map(ConnectedTransactionsData, item => {
                                                       return {MarketName:_.get(item,'MarketName'), ClaimedByUserID: _.get(item, 'SaleData.ClaimedByUserID'), ClaimedByUserAt: _.get(item, 'SaleData.ClaimedByUserAt'), ProductState: _.get(item, 'SaleData.ProductState','')}
                                                   })
                                               } else {
                                                   var transactionsToCheck = _.get(record, 'allOrderTransactions', [])
                                               }
                                               transactionsToCheck = _.filter(transactionsToCheck,item=>{
                                                   var MarketsToCheck = [_.get(this.props, 'searchBoxReference.state.filterOptions.Market', 'n/a')]

                                                   var SubMarkets =_.get(config.warehouseData[ _.get(this.props, 'searchBoxReference.state.filterOptions.Market', 'n/a')],'SubMarkets', [])
                                                   if (SubMarkets.length){
                                                       MarketsToCheck =   _.concat(MarketsToCheck,SubMarkets)
                                                   }
                                                   return _.includes(MarketsToCheck,item.MarketName)
                                               })
                                               var allTransactionsPlucked = transactionsToCheck.length > 0 ? _.every(transactionsToCheck, item => {
                                                   return item.ProductState == 'Plucked' || item.ProductState == 'Packed'
                                               }) : false;
                                               var allTransactionsPacked = transactionsToCheck.length > 0 ? _.every(transactionsToCheck, item => {
                                                   return item.ProductState == 'Packed'
                                               }) : false;
                                                var claimedTransactionExists = transactionsToCheck.length > 0 ? _.some(transactionsToCheck, item => {
                                                    return _.get(item,'ClaimedByUserID') &&  moment().diff(moment(_.get(item, 'ClaimedByUserAt')),'minutes') <120
                                               }) : false;
                                               var status =  'Un-Plucked'
                                               if (allTransactionsPlucked) {
                                                   status =  'Plucked'
                                               }
                                               if (allTransactionsPacked){
                                                   status =  'Packed'
                                               }
                                               return <div>
                                                   <span>{status}</span>
                                                   { claimedTransactionExists  &&
                                                   <div><a href="" className="pleft5  "
                                                             onClick={(e) => {
                                                                 e.preventDefault()

                                                                 this.props.prepareMultipleOrdersScreen(record, 'RemoveClaimsForTransactions')
                                                             }}
                                                   >Claimed</a></div>
                                                   }
                                               </div>
                                           }}}>Status</TableHeaderColumn>
                    <TableHeaderColumn width="60px" dataAlign="center"
                                       columnClassName={  'table-cell-with-image' }
                                       dataFormat={(cell, row, columnIndex, rowIndex) => {
                                           return imagesFormatter.call(this,  row,  rowIndex,{
                                               displayMultipleImages:true,
                                               imagePath:   ['allOrderProductsImages'],
                                               imageTitlePath:['ProductName'],
                                           //    total:this.props.total,
                                               perPage:this.state.perPage,
                                           //    currentPage:this.props.currentPage,
                                           } )
                                       }}
                                       dataField=''>Images</TableHeaderColumn>
                    <TableHeaderColumn width="80px" dataAlign="center"
                                       editable={ false }
                                       dataFormat={ this.customActionsFormatter.bind(this) }>Actions</TableHeaderColumn>
                </BootstrapTable>

            </div>
        );
    }
}


export default AdminFulfillmentListTable;
